// cimage

import React from "react";
import { StyleSheet, Image,ImageBackground} from "react-native";
import CarLoanIndex from "../assets/images/carLoanIndex.png"
import BackIcon from '../assets/images/back_icon.png'
import dropdownArrow from '../assets/images/dropdown_arrow.png'
import TI24HourRecurring from "../assets/images/ti24HourRecurring.svg";
import TIAnnualInsurance from "../assets/images/tiAnnualInsurance.svg";
import WarningSign from "../assets/images/serviceReq/warning_sign.svg";
import TI24HourStandalone from "../assets/images/ti24HourStandalone.svg";
import ICArrow from '../assets/images/icon_arrow_right.png';
import InfoIcon from '../assets/images/info.png';
import UpdateMobile from '../assets/images/mobile_update.png';
import KycUpdate from '../assets/images/kyc_update.png';
import RefreshIcon from '../assets/images/refresh.png';
import CancelPolicy from '../assets/images/cancel_policy_error.png';
import ti24SCancel from '../assets/images/ti24SCancel.png';
import IcForward from "../assets/images/icon_forward.png";
import IcToll from "../assets/images/ic_toll.png";
import IcTickActive from "../assets/images/Tick_Active.png"
import IcCar from "../assets/images/car.png"
import IcSearch from "../assets/images/search_icon.png"
import IcSuccess from "../assets/images/Success.png"
import IcError from "../assets/images/error.png";
import IcPaymentLogos from "../assets/images/payment_logos.png";
import IcTagClosure from '../assets/images/icon_tagclosure.png';
import IcAadhar from "../assets/images/icon_aadhar.png"
import IconHotlistInfo from "../assets/images/hotlist_info_icon.png"
import IconHotlistInfoActive from "../assets/images/hotlist_info_icon_active.png"
import IconHotlistError from "../assets/images/hotlist_error_icon.png"
import IconTickActive from "../assets/images/digilocker_tick_active.png";
import MPBanner01 from "../assets/images/maxpro/mp_benefits_banner_01.png";
import MPBanner02 from "../assets/images/maxpro/mp_benefits_banner_02.png";
import MPBanner03 from "../assets/images/maxpro/mp_benefits_banner_03.png";
import MPBanner04 from "../assets/images/maxpro/mp_benefits_banner_04.png";
import MPDetailsBannerImg from "../assets/images/maxpro/mp_benefits_details_banner.png";
import MpCoveredPic from "../assets/images/maxpro/mp_covered_icon.png";
import MpGetMaxPic from "../assets/images/maxpro/mp_get_max_icon.png";
import MPBanner05 from "../assets/images/maxpro/mp_benefits_banner_05.png";
import MPBannerLowBalMobilePic from "../assets/images/maxpro/mp_benefits_banner_low_bal_mobile.png";
import MPHomeHeaderPic from "../assets/images/maxpro/mp_home_header.png";
import MPHomeBannerPic from "../assets/images/maxpro/mp_home_banner.png";
import MPHomeBadgePic from "../assets/images/maxpro/mp_premium_badge.png";
import MPHomeBannerTextPic from "../assets/images/maxpro/mp_home_banner_text.png";
import MPLeftArrowPic from "../assets/images/maxpro/mp_header_left_arrow.png";
import MPRightArrowPic from "../assets/images/maxpro/mp_header_right_arrow.png";
import MPListIconPic1 from "../assets/images/maxpro/mp_list_icon1.png";
import MPListIconPic2 from "../assets/images/maxpro/mp_list_icon2.png";
import MPListIconPic3 from "../assets/images/maxpro/mp_list_icon3.png";
import MPListIconPic4 from "../assets/images/maxpro/mp_list_icon4.png";
import MPListIconPic5 from "../assets/images/maxpro/mp_list_icon5.png";
import NpciImg from "../assets/images/rectangle53.png";
import AmitabImg from "../assets/images/Amitab.png";
import BackButton from  "../assets/images/red_backbutton.png";
import DropdownArrow from "../assets/images/dropdown_arrow.png";
import chainLink from "../assets/images/chainlink.png";
import iconSuccesIinlineModal from "../assets/images/ic_success_ccavenue.png";
import iconFilter from "../assets/images/icon_filter.png"
import iconNoResult from "../assets/images/icon_no_result.png";

const roundArrowGreen = require("../assets/images/roundArrowGreenIcon.png");



const styles = StyleSheet.create({
    usedCarLoanIndex: {
        width: 274,
        height: 197
    },
    backIcon: {
        width: 19,
        height: 19
    },
    LoanStatusIcon: {
        width: 47.3,
        height: 47.3
    },
    carImgstyle:{
        width: 51.5,
        height: 47,
        borderRadius: 10,
        backgroundColor: "#ccd0d5",
        marginVerticle: 10,
    },
    dropDownArrowStyle:{
        width:14,
        height:7,
        marginTop:2
    },
    searchIconStyle: {
        width: 13,
        height: 12.5,
        resizeMode: "contain",
      },
      succesIconStyle: {
        marginVertical: 15,
        width: 38,
        height: 38,
    },
    errorIconStyle: {
        marginVertical: 15,
        width: 45,
        height: 42,
    },
    paymentLogosStyle:{
        width:200,
        height:76,
        resizeMode: "contain",
    },
    iconTagclosure:{
        width:34,
        height:22
    },
    iconAadharStyle:{
        width:43,
        height:32
    },
    iconHotlistStyle:{
        width:16,
        height:16,
        marginLeft:5,
        marginTop:5
    },
    IconHotlistErrorStyle:{
        width:54,
        height:49
    },
    IconTickActiveStyle:{
        width:13,
        height:13
    },
    mpBannerStyle:{
        width:300,
        height:120,
        marginVertical:10,
        marginRight:20
    },
    mpDetailBannerStyle:{
        width:300,
        height:195,
    },
    mpCoveredIconStyle:{
        width:82,
        height:32
    },
    mpBannerStyleLowBal:{
        width:300,
        height:256,
    },
    mPHomeHeaderPicStyle:{
        width:259,
        height:29,
        marginTop:-40,
        alignSelf:'center'
    },
    mPHomeBannerStyle:{
        width:504,
        height:430,
    },
    mPHomeBadgeStyle:{
        width:62,
        height:56
    },
    mPHomeBannerTextStyle:{
        width:250,
        height:56
    },
    mpArrowStyle:{
        width:84,
        height:21,
        resizeMode:'contain'
    },
    mpListIconStyle:{
        width:28,
        height:28,
    },
    npciImageStyle: {
        width: 200.6,
        height: 45.1,
        alignSelf: "flex-start",
    },
    backbutton: {
        width: 19,
        height: 19,
        marginRight: 20,
        paddingTop: 5.4,
        paddingRight: 7.7,
        paddingBottom: 5.8,
        paddingLeft: 6.7,
      },
      iconDropdown:{
        width:18,
        height:9,
        marginTop:2,
        },
     chainLink: {
         width: 17.9,
         height: 22.2,
          },
      iconSuccesIinlineModalStyle: {
            marginTop: 25,
            width: 27,
            height: 26,     
    },
    iconFilterStyle: {
        width: 30,
        height: 30,
        marginLeft: 10,
      },
      iconNoResultStyle: {
        width: 100,
        height: 100,
        marginBottom: 30,
      },
 AmitabImgStyle:{ width: "30%", height: "100%", resizeMode: "cover" }

});



const iconNoResultBg = React.memo(() => <Image style={styles.iconNoResultStyle} source={iconNoResult} />);

const iconFilterBg = React.memo(() => <Image style={styles.iconFilterStyle} source={iconFilter} />);
const iconSuccesIinlineModalBg = React.memo(() => <Image style={styles.iconSuccesIinlineModalStyle} source={iconSuccesIinlineModal} />);
const chainLinkIcon = React.memo(() => <Image style={styles.chainLink} source={chainLink} />);
const dropdownArrowBg = React.memo(() => <Image style={styles.iconDropdown} source={DropdownArrow} />);
const backButtonIcon = React.memo(() => <Image style={styles.backbutton} source={BackButton} />);
const AmitabImage = React.memo(() => <Image style={styles.AmitabImgStyle} source={AmitabImg} />);
const NpciImage = React.memo(() => <Image style={styles.npciImageStyle} source={NpciImg} />);
const backIcon = React.memo(({ children, ...otherProps }) => (<Image source={BackIcon} style={{ ...styles.backIcon, ...otherProps.style }}>{children}</Image>));
const usedCarLoanIndex = React.memo(({ children, ...otherProps }) => (<Image source={CarLoanIndex} style={{ ...styles.usedCarLoanIndex, ...otherProps.style }}>{children}</Image>));
const LoanStatusIcon = React.memo(({ children, ...otherProps }) => (<Image source={otherProps.src} style={{ ...styles.LoanStatusIcon, ...otherProps.style }}>{children}</Image>));
const dropdownArrowIcon = React.memo((props) => (<Image style={{ width: 18, height: 9, ...props.style }} source={dropdownArrow} />));
const roundArrowGreenIcon = React.memo((props) => <Image style={{ width: 20, height: 20, ...props.style }} source={roundArrowGreen} /> );
const dashboardIcon = React.memo(() => <Image style={{ width: 22, height: 22, }} source={require("../assets/images/Dashboard_gray.png")} />);
const dashboardIconActive = React.memo(() => <Image style={{ width: 22, height: 22, }} source={require("../assets/images/Dashboard.png")} />);
const profileIcon = React.memo(() => <Image style={{ width: 22, height: 22, }} source={require("../assets/images/Profile.png")} />);
const profileIconActive = React.memo(() => <Image style={{ width: 22, height: 22, }} source={require("../assets/images/Profile_white.png")} />);
const statementIcon = React.memo(() => <Image style={{ width: 19, height: 24, }} source={require("../assets/images/Account_Statement.png")} />);
const statementIconActive = React.memo(() => <Image style={{ width: 19, height: 24, }} source={require("../assets/images/Account_Statement_white.png")} />);
const rechargeIcon = React.memo(() => <Image style={{ width: 26, height: 26, }} source={require("../assets/images/Recharge_Amount.png")} />);
const rechargeIconActive = React.memo(() => <Image style={{ width: 26, height: 26, }} source={require("../assets/images/Recharge_white.png")} />);
const disputeIcon = React.memo(() => <Image style={{ width: 30, height: 28, }} source={require("../assets/images/Disputes.png")} />);
const disputeIconActive = React.memo(() => <Image style={{ width: 30, height: 28, }} source={require("../assets/images/Disputes_white.png")} />);
const serviceReqIcon = React.memo(() => <Image style={{ width: 22, height: 24, }} source={require("../assets/images/Service_Request.png")} />);
const serviceReqIconActive = React.memo(() => <Image style={{ width: 22, height: 24, }} source={require("../assets/images/Service_Request_white.png")} />);
const otherServiceIcon = React.memo(() => <Image style={{ width: 22, height: 24, }} source={require("../assets/images/Service_Request.png")} />);
const otherServiceIconActive = React.memo(() => <Image style={{ width: 22, height: 24, }} source={require("../assets/images/Service_Request_white.png")} />);
const helpIcon = React.memo(() => <Image style={{ width: 22, height: 24, }} source={require("../assets/images/help.png")} />);
const helpIconActive = React.memo(() => <Image style={{ width: 22, height: 24, }} source={require("../assets/images/help_active.png")} />);
const transferIcon = React.memo(() => <Image style={{ width: 22, height: 24, }} source={require("../assets/images/Funds_Transfer.png")} />);
const transferIconActive = React.memo(() => <Image style={{ width: 22, height: 24, }} source={require("../assets/images/Funds_Transfer_white.png")} />);
const HamburgerMenuWhite = React.memo(() => <Image style={{ width: 24, height: 20 }} source={require("../assets/images/hamburger_menu_white.png")} />);
const HamburgerMenu = React.memo(() => <Image style={{ width: 24, height: 20 }} source={require("../assets/images/hamburger_menu.png")} />);
const CloseIcon1 = React.memo(() => <Image style={{ width: 24, height: 20 }} source={require("../assets/images/close.png")} />);
const ti24HourRecurringIcon = React.memo((props) => <Image style={{ width: 58, height: 58, ...props.style }} source={TI24HourRecurring} /> );
const tiAnnualInsuranceIcon =React.memo((props) => <Image style={{ width: 58, height: 58, ...props.style }} source={TIAnnualInsurance} /> );
const ti24HourStandaloneIcon = React.memo((props) => <Image style={{ width: 58, height: 58, ...props.style }} source={TI24HourStandalone} /> );
const icArrowIcon = React.memo(() => <Image style={{ width: 5, height: 9 }} source={ICArrow} /> );
const _infoIcon = React.memo(() => <Image style={{ width: 15, height: 15 }} source={InfoIcon} /> );
const cancelPolicyIcon = React.memo(() => <Image style={{ width: 90, height: 90 }} source={CancelPolicy} /> );
const CarImage = React.memo(() => <Image style={styles.carImageStyle} source={require("../assets/images/used_car.png")} />);
const tiLogo = React.memo(() => <Image style={{width:50, height:50}} source={require("../assets/images/tiLogo.png")} />);
const benefitLogo = React.memo(() => <Image style={{width:66, height:66}} source={require("../assets/images/benefitLogo.png")} />);
const OptInsPic = React.memo(() => <Image style={{width:170, height:130, marginBottom:10,}} source={require("../assets/images/opt-insurance-pic.png")} />);
const MyInsPic = React.memo(() => <Image style={{width:170, height:130,marginBottom:10,marginLeft:14,marginRight:4}} source={require("../assets/images/my-insurance-pic.png")} />);
const ClaimInsPic = React.memo(() => <Image style={{width:170, height:132, }} source={require("../assets/images/insurance-claim-pic.png")} />);

const OptInsPicMobile = React.memo(() => <Image style={{width:90, height:114, marginBottom:10,}} source={require("../assets/images/opt-insurance-pic-mobile.png")} />);
const MyInsPicMobile = React.memo(() => <Image style={{width:90, height:114,marginBottom:10,marginLeft:10,marginRight:4}} source={require("../assets/images/my-insurance-pic-mobile.png")} />);
const ClaimInsPicMobile = React.memo(() => <Image style={{width:114, height:120,marginRight:15 }} source={require("../assets/images/insurance-claim-pic-mobile.png")} />);
const IconCertificate = React.memo(() => <Image style={{width:35, height:35, }} source={require("../assets/images/icon_tnc.png")} />);
const IconTransaction = React.memo(() => <Image style={{width:35, height:35, marginHorizontal:16}} source={require("../assets/images/icon_transactions.png")} />);
const IconHistory = React.memo(() => <Image style={{width:35, height:35, }} source={require("../assets/images/icon_disputes.png")} />);
const IconFaq = React.memo(() => <Image style={{width:35, height:35, }} source={require("../assets/images/icon_faq.png")} />);
const AlertIcon = React.memo(() => <Image style={{width:38, height:34, }} source={require("../assets/images/error.png")} />);
const CarIcon = React.memo(() => <Image style={{width:36, height:38, }} source={require("../assets/images/icon_car.png")} />);
const UpdateMobileImage = React.memo(() => <Image style={{width:63, height:67, }} source={UpdateMobile} />);
const KycUpdateImage = React.memo(() => <Image style={{width:63, height:67, }} source={KycUpdate} />);
const BenifitImage = React.memo((props) => <Image style={{width:20, height:20,resizeMode:"contain",color:"red" }} source={props.source} />);
const RefreshImage = React.memo(() => <Image style={{width:12, height:13,marginRight:8 }} source={RefreshIcon} />);
const Ti24SCancelImage = React.memo(() => <Image style={{width:90, height:90, }} source={ti24SCancel} />);
const DisputeImage = React.memo(() => <Image style={{width:223, height:172, }} source={require("../assets/images/disputeImage.png")} />);
const IconForward = React.memo((props) => <Image style={{width:14, height:14,marginLeft:6,marginTop:2, ...props.style }} source={IcForward} />);
const IconToll = React.memo(() => <Image style={{width:27, height:21, }} source={IcToll} />);
const TickActive =React.memo(() => <Image style={{width:17, height:17, }} source={IcTickActive} />);
const CarImg =React.memo(() => <Image style={styles.carImgstyle} source={IcCar} />);
const CarIconRc =React.memo(() => <Image style={{width: 51, height: 47, resizeMode: "contain" }} source={require("../assets/images/car.png")} />);
const DropDownArrow =React.memo(() => <Image style={styles.dropDownArrowStyle} source={dropdownArrow} />);
const IconSearch =React.memo(() => <Image style={styles.searchIconStyle} source={IcSearch} />);
const IconSuccess =React.memo(() => <Image style={styles.succesIconStyle} source={IcSuccess} />);
const IconError =React.memo(() => <Image style={styles.errorIconStyle} source={IcError} />);
const PaymentLogos =React.memo(() => <Image style={styles.paymentLogosStyle} source={IcPaymentLogos} />);
const IconTagClosure =React.memo(() => <Image style={styles.iconTagclosure} source={IcTagClosure} />);
const IconAadhar =React.memo(() => <Image style={styles.iconAadharStyle} source={IcAadhar} />);
const HotlistInfoIcon =React.memo(() => <Image style={styles.iconHotlistStyle} source={IconHotlistInfo} />);
const HotlistInfoIconActive =React.memo(() => <Image style={styles.iconHotlistStyle} source={IconHotlistInfoActive} />);
const HotlistErrorIcon =React.memo(() => <Image style={styles.IconHotlistErrorStyle} source={IconHotlistError} />);
const DigilockerTickIcon =React.memo(() => <Image style={styles.IconTickActiveStyle} source={IconTickActive} />);
const MPBenefitBanner01 =React.memo(() => <Image style={styles.mpBannerStyle} source={MPBanner01} />);
const MPBenefitBanner02 =React.memo(() => <Image style={styles.mpBannerStyle} source={MPBanner02} />);
const MPBenefitBanner03 =React.memo(() => <Image style={styles.mpBannerStyle} source={MPBanner03} />);
const MPBenefitBanner04 =React.memo(() => <Image style={styles.mpBannerStyle} source={MPBanner04} />);
const MPDetailsBanner =React.memo(() => <Image style={styles.mpDetailBannerStyle} source={MPDetailsBannerImg} />);
const MPCoveredIcon =React.memo(() => <Image style={styles.mpCoveredIconStyle} source={MpCoveredPic} />);
const MPBenefitBanner05 =React.memo(() => <Image style={styles.mpBannerStyleLowBal} source={MPBanner05} />);
const MPBannerLowBalMobile =React.memo(() => <Image style={styles.mpBannerStyle} source={MPBannerLowBalMobilePic} />);
const MPHomeHeader =React.memo(() => <Image style={styles.mPHomeHeaderPicStyle} source={MPHomeHeaderPic} />);
const MPHomeBanner =React.memo(() => <ImageBackground resizeMode="cover" style={styles.mPHomeBannerStyle} source={MPHomeBannerPic} > </ImageBackground>);
const MPHomeBadge =React.memo(() => <Image style={styles.mPHomeBadgeStyle} source={MPHomeBadgePic} />);
const MPHomeBannerText =React.memo(() => <Image style={styles.mPHomeBannerTextStyle} source={MPHomeBannerTextPic} />);
const MPHeaderLeftArrow =React.memo(() => <Image style={styles.mpArrowStyle} source={MPLeftArrowPic} />);
const MPHeaderRightArrow =React.memo(() => <Image style={styles.mpArrowStyle} source={MPRightArrowPic} />);
const MPListIcon1 =React.memo(() => <Image style={styles.mpListIconStyle} source={MPListIconPic1} />);
const MPListIcon2 =React.memo(() => <Image style={styles.mpListIconStyle} source={MPListIconPic2} />);
const MPListIcon3 =React.memo(() => <Image style={styles.mpListIconStyle} source={MPListIconPic3} />);
const MPListIcon4 =React.memo(() => <Image style={styles.mpListIconStyle} source={MPListIconPic4} />);
const MPListIcon5 =React.memo(() => <Image style={styles.mpListIconStyle} source={MPListIconPic5} />);
const MPGetMaxIcon =React.memo(() => <Image style={styles.mpCoveredIconStyle} source={MpGetMaxPic} />);
const MPShieldSmallIconPNG = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 20, height: 24, ...style }} source={require("../assets/images/maxpro/mp_shield_small_icon.png")} />);
const MpShieldBlueSmallIconPNG = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 20, height: 24, ...style }} source={require("../assets/images/maxpro/mp_shield_blue_small_icon.png")} />);
const MpShieldBlueHomeIconPNG = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 65, height: 63,alignSelf:'center', ...style }} source={require("../assets/images/maxpro/mp_shield_blue_home_icon.png")} />);
const MpOptOutIcon = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 19, height: 20, marginRight:10,alignSelf:'center', ...style }} source={require("../assets/images/maxpro/mp_opt_out_icon.png")} />);
const CloseIcon = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 30, height: 30, position:'absolute',right:20,top:-50, ...style }} source={require("../assets/images/maxpro/close_icon.png")} />);
const ErrorIconWithBg = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 80, height: 80, alignSelf:'center', ...style }} source={require("../assets/images/maxpro/error_icon.png")} />);
const DefaultProfilePic = React.memo(() => <Image style={{ height: "80%", width: "80%", resizeMode: "center", marginTop: 10, }} source={require("../assets/images/default_profile.png")} />);
const DefaultProfilePicSml = React.memo(() => <Image style={{ height: 60, width: 60, borderRadius: 80 }} source={require("../assets/images/default_profile.png")} />);
const UpdateKycIcon = React.memo(() => <Image style={{ width: 40, height: 30, resizeMode: "center" }} source={require("../assets/images/updateKyc.png")} />);
const AddVehiclIcon = React.memo(() => <Image style={{ width: 40, height: 30, resizeMode: "center" }} source={require("../assets/images/Add_Vehicle_Icon.png")} />);
const AddVehicleWhite = React.memo(() => <Image style={{ width: 28, hieght: 18, resizeMode: "center" }} source={require("../assets/images/Add_vehicle_white.png")} />);
const RightArrowBig = React.memo(() => <Image style={{ width: 20, height: 20,resizeMode: "center",marginLeft: 10, }} source={require("../assets/images/right_arrow.png")} />);
const RightArrowSmall = React.memo(() => <Image style={{ width: 15, height: 15,resizeMode: "center",marginLeft: 5, }} source={require("../assets/images/right_arrow.png")} />);
const PlaystoreIcon = React.memo(() => <Image style={{  marginLeft: -20,width: 153,height: 90,resizeMode: "contain", }} source={require("../assets/images/google_playstore.png")} />);
const AppstoreIcon = React.memo(() => <Image style={{  width: 90, height: 70, resizeMode: "contain", }} source={require("../assets/images/appstore.png")} />);
const FFLogo = React.memo(() => <Image style={{  height: 40, width: 230,marginTop: 10,resizeMode: "contain",}} source={require("../assets/images/FF_logo.png")} />);
const QRCodeIcon = React.memo(() => <Image style={{  width: 53, height: 53}} source={require("../assets/images/QRCode.png")} />);
const IDFCLogo = React.memo(() => <Image style={{height: 40, width: 120,marginLeft: 25,resizeMode: "contain",}} source={require("../assets/images/IDFC_Logo.png")} />);
const FFLogoSmall = React.memo(() => <Image style={{  height: 40, width:150, resizeMode: "contain",}} source={require("../assets/images/FF_logo.png")} />);
const PlaystoreIconMobile = React.memo(() => <Image style={{  marginLeft:12,width: 153,height: 90,resizeMode: "contain", }} source={require("../assets/images/google_playstore.png")} />);
const AppstoreIconMobile = React.memo(() => <Image style={{  width: 90, height: 70, marginLeft:12, resizeMode: "contain", }} source={require("../assets/images/appstore.png")} />);
const InputUserIcon = React.memo(() => <Image style={{ width: 20, height: 20, resizeMode: "center", position: "absolute",right: 10,top: 10, }} source={require("../assets/images/UID.png")} />);
const ReloadCaptchaIcon = React.memo(() => <Image style={{ width: 20, height: 20, resizeMode: "center", }} source={require("../assets/images/Reload_Captcha.png")} />);
const BackIconWhite = React.memo(() => <Image style={{ width: 20, height: 20, resizeMode: "center", }} source={require("../assets/images/back_icon_white.png")} />);
const PasswordIcon = React.memo(() => <Image style={{ width: 20, height: 20, resizeMode: "center", }} source={require("../assets/images/Password.png")} />);
const FaqCtaImg = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 150, height: "100%", ...style }} source={require("../assets/images/sing.png")} />);
const ArrowUpIcon = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 10, height: 10, alignSelf: "center", ...style }} source={require("../assets/images/arrow_up.png")} />);
const ArrowDownIcon = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 10, height: 10, alignSelf: "center", ...style }} source={require("../assets/images/arrow_down.png")} />);
const TripInsInfoIcon = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 16, height: 16,marginRight:10, alignSelf: "center", ...style }} source={require("../assets/images/info_icon.png")} />);
const LoginTitleIcon = React.memo(({ style }) => <Image resizeMode="contain" style={{ height: 20, width: 20, resizeMode: "center", ...style }} source={require("../assets/images/Login.png")} />);
const WhatsAppIcon = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 20, height: 20, resizeMode: "center", ...style }} source={require("../assets/images/whatsapp_icon.png")} />);

const SrUpdateMobileIcon = React.memo(() => <Image style={{ width: 37, height: 37 }} source={require("../assets/images/serviceReq/sr_update_mobile.png")} />);
const SrCloseTagIcon = React.memo(() => <Image style={{ width: 37, height: 37 }} source={require("../assets/images/serviceReq/sr_close_tag.png")} />);
const SrDisputesIcon = React.memo(() => <Image style={{ width: 37, height: 37 }} source={require("../assets/images/serviceReq/sr_disputes.png")} />);
const SrUpdateVehicleIcon = React.memo(() => <Image style={{ width: 37, height: 37 }} source={require("../assets/images/serviceReq/sr_update_vehicle.png")} />);
const SrUpdateKycIcon = React.memo(() => <Image style={{ width:37, height: 37 }} source={require("../assets/images/serviceReq/sr_update_kyc.png")} />);
const SrArrowIcon = React.memo(() => <Image style={{ width:24, height: 24 }} source={require("../assets/images/serviceReq/sr_arrow.png")} />);
const IconTip = React.memo(() => <Image style={{ width:24, height: 51,marginRight:10 }} source={require("../assets/images/disputes/icon_tip.png")} />);
const SearchIconExp = React.memo(() => <Image style={{ width: 13, height: 12,resizeMode: "contain", position: "absolute", zIndex: 99,right: 10, top: 10, bottom: 0, }} source={require("../assets/images/searchIcon.png")} />);
const NavIconRight = React.memo(() => <Image style={{  width: 5,height: 9,marginTop: 4, marginLeft: 4, }} source={require("../assets/images/nav_arrow_right.png")} />);
const CarImgAR = React.memo(() => <Image style={{  width: 71.2, height: 65.8, resizeMode: "center",}} source={require("../assets/images/car.png")} />);
const IconRightAR = React.memo(() => <Image style={{ width: 8.4, height: 12.9,resizeMode: "contain",}} source={require("../assets/images/icon_arrow_right.png")} />);
const FuelIcon = React.memo(() => <Image style={{ width: "100%", height: "100%", resizeMode: "contain"}} source={require("../assets/images/fuel_icon1.png")} />);
const FuelBanner = React.memo(() => <Image style={{ width: "100%", height: "100%", resizeMode: "contain"}} source={require("../assets/images/fuelBanner.png")} />);
const WarningSignIcon = React.memo(() => <Image style={{ width:30, height: 27, resizeMode: "contain"}} source={WarningSign} />);
const IconHand = React.memo(() => <Image style={{ width:80, height: 105, resizeMode: "contain",position:'absolute',bottom:0,right:0}} source={require("../assets/images/serviceReq/icon_hand.png")} />);
const CarImgGray =React.memo(() => <Image style={styles.carImgstyle} source={require("../assets/images/serviceReq/icon_car_gray.png")} />);
const IconMPGray =React.memo(() => <Image style={{width:80,height:30,resizeMode: "contain",}} source={require("../assets/images/serviceReq/icon_mp_gray.png")} />);
const qrcodeIcon =React.memo(() => <Image style={{width:80,height:30,resizeMode: "contain",}} source={require("../assets/images/qrcodeIcon.png")} />);
const downloadIcon =React.memo(() => <Image style={{width:20,height:20,resizeMode: "contain",}} source={require("../assets/images/download_icon.png")} />);
const insurancePolicyIcon =React.memo(() => <Image style={{width:70,height:70,resizeMode: "contain",}} source={require("../assets/images/icon_ins_policy.png")} />);
const filterDownArrow = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 10, height: 10, ...style }} source={require("../assets/images/arrow_down.png")} />);
const filterUpArrow = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 10, height: 10, ...style }} source={require("../assets/images/arrow_up.png")} />);
const xls = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 10, height: 10, ...style }} source={require("../assets/images/xls.png")} />);
const close = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 12, height: 12, ...style }} source={require("../assets/images/close2.png")} />);
const calendar = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 12, height: 12, ...style }} source={require("../assets/images/calendar.png")} />);
const pdf = React.memo(({ style }) => <Image resizeMode="contain" style={{ width: 10, height: 10, ...style }} source={require("../assets/images/pdfIcon.png")} />);
const SrUpdateKYVIcon = React.memo(() => <Image style={{ width: 37, height: 37 }} source={require("../assets/images/serviceReq/updateKYVSr.png")} />);
const KYVCompleteIcon = React.memo(() => <Image style={{ width: 36, height: 36, resizeMode: "center", }} source={require("../assets/images/KYVCompleteIcon.png")} />);



export default {ti24HourRecurringIcon,tiAnnualInsuranceIcon,
    CarImage,tiLogo,benefitLogo,icArrowIcon,
    ti24HourStandaloneIcon,filterDownArrow,filterUpArrow,xls,close,calendar,pdf,
     usedCarLoanIndex, backIcon, LoanStatusIcon, dropdownArrowIcon,roundArrowGreenIcon,dashboardIcon, dashboardIconActive,
     profileIcon, profileIconActive, statementIcon, statementIconActive, rechargeIcon, rechargeIconActive, disputeIcon, disputeIconActive,
     serviceReqIcon, serviceReqIconActive, otherServiceIcon, otherServiceIconActive, helpIcon, helpIconActive, transferIcon, transferIconActive,
     HamburgerMenuWhite, HamburgerMenu, CloseIcon1,OptInsPic,MyInsPic,
     ClaimInsPic, IconCertificate,IconTransaction,IconHistory,AlertIcon,CarIcon,_infoIcon,UpdateMobileImage,KycUpdateImage,BenifitImage,RefreshImage,cancelPolicyIcon,Ti24SCancelImage,DisputeImage,
     IconForward, IconToll, TickActive, CarImg, DropDownArrow, IconSearch, IconSuccess, IconError, PaymentLogos,
     IconTagClosure, IconAadhar, HotlistInfoIcon, HotlistInfoIconActive,HotlistErrorIcon, DigilockerTickIcon,
     MPBenefitBanner01, MPBenefitBanner02, MPBenefitBanner03, MPBenefitBanner04, MPDetailsBanner, MPCoveredIcon, MPBenefitBanner05,
     MPBannerLowBalMobile, MPHomeHeader, MPHomeBanner, MPHomeBadge, MPHomeBannerText, MPHeaderLeftArrow, MPHeaderRightArrow,
     MPListIcon1, MPListIcon2, MPListIcon3, MPListIcon4, MPListIcon5, MPGetMaxIcon, MPShieldSmallIconPNG,
     MpShieldBlueSmallIconPNG, MpShieldBlueHomeIconPNG, MpOptOutIcon, CloseIcon, ErrorIconWithBg,
    DefaultProfilePic,AddVehicleWhite,DefaultProfilePicSml,UpdateKycIcon,AddVehiclIcon, RightArrowBig, RightArrowSmall, PlaystoreIcon, AppstoreIcon,
    FFLogo, QRCodeIcon, IDFCLogo, FFLogoSmall, PlaystoreIconMobile, AppstoreIconMobile, InputUserIcon, ReloadCaptchaIcon, BackIconWhite, PasswordIcon,
     NpciImage,AmitabImage, TripInsInfoIcon, LoginTitleIcon, WhatsAppIcon, ArrowDownIcon,TripInsInfoIcon,FaqCtaImg, ArrowUpIcon,FuelIcon,FuelBanner,
     SrUpdateMobileIcon, SrCloseTagIcon, SrDisputesIcon, SrUpdateVehicleIcon, SrUpdateKycIcon, SrArrowIcon, IconTip,CarIconRc, SearchIconExp, NavIconRight,CarImgAR,IconRightAR,backButtonIcon,dropdownArrowBg,chainLinkIcon,iconSuccesIinlineModalBg,iconFilterBg,iconNoResultBg,
     WarningSignIcon, IconHand, CarImgGray, IconMPGray,downloadIcon,qrcodeIcon,insurancePolicyIcon,IconFaq,
     OptInsPicMobile, MyInsPicMobile, ClaimInsPicMobile,SrUpdateKYVIcon,KYVCompleteIcon
 };

    
